import { render } from "./App.vue?vue&type=template&id=f280aa3e"
const script = {}

import exportComponent from "/home/smallred/20250930/inrunonline-website-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__